export { default } from './EzButtonDropdown.vue';
